export default "__VITE_ASSET__4bee1645__"